var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIconNotification = function SvgIconNotification(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#88817E;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st0",
    d: "M14.9,8.2c0.3,0.4,0.7,0.8,1.3,0.9c0.5,0.1,0.9,0.2,1.3,0.4c1.1,0.5,2.2,1.7,2.2,3.4v3.8 c0,2.1,0.5,4,1.5,5.8l-0.8,0.1c-2.3,0.4-3.9,0.6-5.5,0.6s-3.2-0.2-5.5-0.6l-0.8-0.1c0.9-1.7,1.4-3.7,1.4-5.8l0-3.8 c0-1.8,1.5-3,2.3-3.4c0.4-0.2,0.8-0.3,1.2-0.4C14.2,9,14.7,8.6,14.9,8.2 M14.9,4.8c-0.9,0-1.7,0.8-1.7,1.7v0.6c0,0,0,0,0,0 c-0.5,0.1-1.1,0.3-1.6,0.5c-1.7,0.8-3.5,2.7-3.5,5.2v3.8c0,2.8-1,5.2-3,7.2l4,0.7c2.3,0.4,4,0.6,5.8,0.6s3.5-0.2,5.8-0.6l4-0.7 c-2-2-3.1-4.4-3.1-7.2v-3.8c0-2.6-1.7-4.4-3.4-5.2c-0.6-0.3-1.1-0.4-1.7-0.6V6.5C16.6,5.6,15.9,4.8,14.9,4.8L14.9,4.8z"
  })));
};
export default SvgIconNotification;